import request from '@/request'

export async function getCourseGroup(type, id, params) {       
        const response = await request({
           url: `/groups/${type}/${id}`,
           method: "get",
           params
        });
  
        return response.data.data;
       }

export async function getCourseGroupReplies(type, id, params) {
        const response = await request({
          url: `/groups/${id}`,
          method: "get",
          params
         });

         return response.data.data;
       }

export async function createCourseGroup(type, id, data) {  
        const response = await request({
          url: `/groups/${type}/${id}`,
          method: "post",
          data
         });

         return response.data.data;
}
       
export async function createCourseGroupReply(data) { 
        const response = await request({
          url: `/groups/${data.type}/${data.courseGroupId}`,
          method: "post",
          data
         });

         return response.data.data;
       }

export async function deleteCourseGroup (courseId, courseGroupId) {
  await request({
    url: `/groups/${courseGroupId}`,
    method: "delete"
  });
}